module.exports = __webpack_public_path__ + "img/w3_exclamation_white.2cf634aa.png";